import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-197f5198")

_pushScopeId("data-v-197f5198")
const _hoisted_1 = {
  key: 0,
  class: "tit"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "num" }
const _hoisted_4 = {
  key: 0,
  class: "cont"
}
const _hoisted_5 = { class: "date" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = {
  key: 2,
  class: "program-btns"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看代码")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_empty = _resolveComponent("el-empty")

  return (_openBlock(), _createBlock("div", {
    class: 'his-box' + (_ctx.type == 5 ? ' is-program' : '')
  }, [
    (_ctx.type !== 5)
      ? (_openBlock(), _createBlock("p", _hoisted_1, "提交记录"))
      : _createCommentVNode("", true),
    (_ctx.newData && _ctx.newData.length > 0)
      ? (_openBlock(), _createBlock("ul", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newData, (item, index) => {
            return (_openBlock(), _createBlock("li", {
              key: item.id
            }, [
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.newData.length - index) + _toDisplayString(_ctx.type === 5 ? '.' : ''), 1),
              (_ctx.type !== 5)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    (_ctx.type === 1)
                      ? (_openBlock(), _createBlock(_component_el_radio, { key: 0 }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.ans[0]), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (_ctx.type === 2)
                      ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                          key: 1,
                          class: "q-cb-group",
                          modelValue: _ctx.checkList,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkList = $event))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.ans, (subItem, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: index,
                                onChange: _ctx.handleCheckboxChange
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(subItem), 1)
                                ]),
                                _: 2
                              }, 1032, ["onChange"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.type === 3)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(item.ans, (subItem, index) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "com-row",
                            key: index
                          }, [
                            _createVNode("span", null, _toDisplayString(index + 1), 1),
                            _createTextVNode(_toDisplayString(subItem), 1)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    (_ctx.type === 4)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 3,
                          type: "textarea",
                          modelValue: item.ans[0],
                          "onUpdate:modelValue": ($event: any) => (item.ans[0] = $event),
                          resize: "none",
                          autosize: { minRows: 3 },
                          readonly: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_5, "提交时间：" + _toDisplayString(_ctx.date(item.createTime)), 1),
              (_ctx.type !== 5)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "text",
                    icon: "el-icon-delete-solid",
                    class: "btn-del",
                    onClick: ($event: any) => (_ctx.handleDelete(item.id))
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.type === 5)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      class: "btn-del",
                      onClick: ($event: any) => (_ctx.handleDelete(item.id))
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      class: "btn-code",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.handleViewCode(item.ans))
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.newData.length < 1)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 2,
          description: "暂无提交记录",
          "image-size": 100
        }))
      : _createCommentVNode("", true)
  ], 2))
})